module.exports = __webpack_public_path__ + "img/bbshomepage1.fc69ae94.png";